/* this file added by Bearer Web Developer  */
import { Timeline, TimelineConnector, TimelineContent, TimelineItem, TimelineSeparator } from '@mui/lab';
import styles from './locations.module.scss';
import BearerTextField from '../../../../components/fields/BearerTextField';
import { useAppState } from '../../../../states/app-state';
import { observer } from 'mobx-react-lite';
import { useThemeMode } from '../../../../states/contexts/theme';

const Locations: React.FC = observer(() => {

    const appState = useAppState();
    const activeManageOrder = appState?.ReservedOrders.activeManageOrder;
    const editData = appState?.ReservedOrders.editOrderApiIntegrationData;
    const { setEditOrderApiIntegrationData } = appState?.ReservedOrders;
    const { theme } = useThemeMode(); // added by Bearer Web Developer
    return (
        <div className={styles.locations} data-theme={theme}> {/* data-theme property added by Bearer Web Developer */}
            <Timeline classes={{ root: styles.time_line }}>
                <TimelineItem classes={{ missingOppositeContent: styles.missing_opposite_content }}>
                    <TimelineSeparator>
                        {
                            theme === 'dark' ? <img src="/origin-dark.svg" alt="origin" /> :
                                <img src="/origin.png" alt="origin" />
                        }
                        <TimelineConnector className={styles.connector} />
                    </TimelineSeparator>
                    <TimelineContent classes={{ root: styles.timeline_content_root }}>
                        <div className={styles.timeline_content}>
                            <p>{activeManageOrder?.origin_address}</p>
                            <span>{activeManageOrder?.origin_details}</span>
                        </div>
                    </TimelineContent>
                </TimelineItem>
                <div className={styles.connector_desktop}><hr /></div>
                <TimelineItem classes={{ missingOppositeContent: styles.missing_opposite_content, root: styles.timelineItem_root }}>
                    <div className={styles.destination_content}>
                        <TimelineSeparator >
                            <img src="/destination.png" alt="destination" />
                        </TimelineSeparator>
                        <TimelineContent classes={{ root: styles.timeline_content_root }}>
                            <div className={styles.timeline_content}>
                                <p>{activeManageOrder?.destination_address}</p>
                            </div>
                        </TimelineContent>
                    </div>
                    <div className={styles.destination_edit}>
                        <BearerTextField
                            colorStyle={theme === "dark" ? 'gray-dark' : 'gray'}
                            placeholder={"Destination Details"}
                            label="Destination Details"
                            value={editData.destination_details}
                            onChange={(e) => setEditOrderApiIntegrationData({ destination_details: e.target.value })}
                            clear={() => { setEditOrderApiIntegrationData({ destination_details: '' }) }}
                        />
                    </div>
                </TimelineItem>
            </Timeline>
        </div>
    )
})
export default Locations;